<div [style.padding] = "top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px'">
    <ng-content></ng-content>
</div>
